import { FC } from 'react';
import { Box, BoxProps, InputProps } from 'theme-ui';
import { getVariant } from '../util/getVariant';

const MaterialInput: FC<
  InputProps & { label: string; boxProperties?: BoxProps }
> = ({ title, label, boxProperties, ...props }) => (
  <Box
    {...getVariant('layout.common.forms.materialInput')}
    {...boxProperties}
    className={`${props.value ? 'filled' : ''} ${boxProperties?.className || ''}`}
  >
    <span>{label}:</span>
    <input {...props} aria-label={label} title={label} />
  </Box>
);

export default MaterialInput;
